import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'datecompat' })
export class DateCompatPipe implements PipeTransform {
    transform(date: string): any {
        return date.replace(/\s/g, 'T');
    }
}

@Pipe({ name: 'datelength' })
export class DateLenghtPipe implements PipeTransform {
    transform(date: string): any {
        let wIndex = -1;
        let wRes = '';
        if (typeof date === 'string') {
            wIndex = date.indexOf('|');
            if (wIndex > 0) {
                wRes = date.substring(0, wIndex);
            }
        }
        return wRes;
    }
}
